import { SchedulerEventType } from '../constants/scheduler-event.type';
import { StatusType } from '../constants/status.type';

export class ScheduledEvent {
  public id?: number;
  public title?: string;
  public start?: Date;
  public end?: Date;
  public startTimezone?: string;
  public endTimezone?: string;
  public duration?: number;
  public readonly?: boolean;
  public available?: boolean;
  public hearingRequestId?: string;
  public reservationId?: string;
  public hearingStatus?: StatusType;
  public readingTime?: number;
  public comments?: string;
  public selected?: boolean;
  public eventType?: SchedulerEventType;
  public justiceName?: string;
  public justiceCode?: string;
  public actionNumber?: string;
  public actionTitle?: string;
  public fromQBSS?: boolean;

  constructor(init?: Partial<ScheduledEvent>) {
    Object.assign(this, init);
  }
}
